/**
 * @description 前端环境配置
 * 统一管理后端 API 地址和其他环境变量
 */

export default {
    // 🎯 后端 API 基准地址（生产环境使用相对路径，开发环境用环境变量）
    backendUrl: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL.replace('/api', '') : '/api',
    
    // 📡 API 路径（注意：如果后端 SecurityConfig 中配置了 /api 前缀，保持此值）
    // 如果你的项目已经全局使用了 RequestUtil 封装请求，可能不需要这个字段
    apiPath: '/api',
    
    // 🔐 JWT Token 存储键名
    tokenKey: 'auth_token',
    
    // ⏱️ 请求超时时间（毫秒）
    timeout: 30000,
    
    // 📱 是否为移动端
    isMobile: false,
    
    // 🧪 开发/生产环境标识
    env: process.env.NODE_ENV || 'development'
};

// 导出配置对象
export const AppConfig = {
    // 快捷方式：获取完整 API 地址
    // 使用示例：const API_BASE = AppConfig.getBaseUrl();
    getBaseUrl: () => {
        const config = getDefault();
        return config.backendUrl;
    },
    
    // 快捷方式：拼接完整 API URL
    // 使用示例：const url = AppConfig.url('/shop/info');
    url: (path) => {
        const config = getDefault();
        // 去除 path 开头的斜杠
        const cleanPath = path.replace(/^\//, '');
        return `${config.backendUrl}/${cleanPath}`;
    }
};

// 获取默认配置
function getDefault() {
    return {
        backendUrl: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL.replace('/api', '') : '/api',
        apiPath: '/api',
        tokenKey: 'jwt_token',
        timeout: 30000,
        isMobile: false,
        env: process.env.NODE_ENV || 'development'
    };
}
